@if (displayedOnPagePanel || fromDataView) {
  <div soho-homepage soho-homepage-sizer [columns]="columns">
    @for (panel of dashboardPanels; track panel) {
      @switch (panel.type) {
        @case ('list') {
          <lm-dashboard-panel-list #dashboardPanel
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (contentModified)="onContentModified($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
          ></lm-dashboard-panel-list>
        }
        @case ('formlist') {
          <lm-dashboard-panel-list #dashboardPanel
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (contentModified)="onContentModified($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
          ></lm-dashboard-panel-list>
        }
        @case ('standardform') {
          <lm-dashboard-panel-form #dashboardPanel
            [panel]="panel"
            [formUrlInfo]="formUrlInfo"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-dashboard-panel-form>
        }
        @case ('form') {
          <lm-dashboard-panel-form #dashboardPanel
            [panel]="panel"
            [formUrlInfo]="formUrlInfo"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [model]="model"
            [placeHolder]="placeHolder"
            [specFields]="specFields"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-dashboard-panel-form>
        }
        @case ('independentform') {
          <lm-dashboard-panel-form #dashboardPanel
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
          ></lm-dashboard-panel-form>
        }
        @case ('templateform') {
          <lm-dashboard-panel-form-template #dashboardPanel
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [model]="model"
            [placeHolder]="placeHolder"
            [specFields]="specFields"
            (componentDisplayed)="onComponentDisplayed()"
          ></lm-dashboard-panel-form-template>
        }
        @case ('instancecountchart') {
          <lm-dashboard-panel-form #dashboardPanel
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-dashboard-panel-form>
        }
        @case ('cardview') {
          <lm-dashboard-panel-card
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            (uiLinkEvent)="onUILinkEvent($event)"
            (componentDisplayed)="onComponentDisplayed()"
          ></lm-dashboard-panel-card>
        }
        @case ('menuPanel') {
          <lm-dashboard-panel-form
            [panel]="panel"
            [fromDataView]="messageRuleView"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-dashboard-panel-form>
        }
        @case ('MenuLinkBoxPanel') {
          <lm-dashboard-panel-form
            [panel]="panel"
            [fromDataView]="messageRuleView"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-dashboard-panel-form>
        }
        @case ('url') {
          <lm-dashboard-panel-url
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            (uiLinkEvent)="onUILinkEvent($event)"
            (componentDisplayed)="onComponentDisplayed()"
          ></lm-dashboard-panel-url>
        }
        @case ('link') {
          <lm-dashboard-panel-url
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            (uiLinkEvent)="onUILinkEvent($event)"
            (componentDisplayed)="onComponentDisplayed()"
          ></lm-dashboard-panel-url>
        }
        <!-- future
        <lm-dashboard-panel-httpurl></lm-dashboard-panel-httpurl>
        -->
      }
    }
  </div>
}
